import CustomerService from './CustomerService'

let instance
const plugin = {
  install (Vue) {
    const CustomerServiceConstructor = Vue.extend(CustomerService)
    if (!instance) {
      instance = new CustomerServiceConstructor()
      instance.$mount()
      document.body.appendChild(instance.$el)
    }

    const service = {
      show (params) {
        if (params) {
          instance.params = params
        }
        if (!instance.show) {
          instance.show = true
        }
      }
    }
    if (!Vue.$common) {
      Vue.$common = {
        CustomerService: service
      }
    } else {
      Vue.$common.CustomerService = service
    }

    Vue.mixin({
      created() {
        this.$common = Vue.$common
      }
    })
  }
}

export default plugin



// WEBPACK FOOTER //
// ./module/order/src/components/CustomerService/index.js